/** Popup stickers duration (milliseconds) */
export const POPUP_STICKERS_DURATION = 7000;
export const VERSION_CHECK_INTERVAL = 1000 * 60 * 1;
